import React from 'react'
import WidgetContainer from '../../containers/WidgetContainer'
import ImagesSection from '../../containers/ImagesSection'
import LinksSection from '../../containers/LinksSection'
import ImageBoxWrapper from './ImageBoxWrapper'
import ArticleImageBox from '../../boxes/StyledArticleImageBox'

export default (props) => {
  const {
    activeDynamicLayout,
    isOpening,
    widget,
    widget: {
      ad,
      boxes = [],
      imageSize = '4_3',
      name,
      utmContent,
      utmMedium,
      utmSource
    }
  } = props

  if (!boxes.length) {
    return null
  }

  const textBoxes = [...boxes]
  const headBoxes = textBoxes.splice(0, 2)

  const utmParams = {
    utmContent,
    utmMedium,
    utmSource
  }

  const renderImageBox = (box, index) => <ImageBoxWrapper
    activeDynamicLayout={activeDynamicLayout}
    box={box}
    imageBoxComponent={ArticleImageBox}
    imageSize={imageSize}
    index={index}
    key={`financeBox${index}`}
    utmParams={utmParams}
  />

  return (
    <WidgetContainer widget={widget} isOpening={isOpening}>
      {
        headBoxes.length > 0 &&
        <ImagesSection boxes={headBoxes} renderBox={renderImageBox}/>
      }
      {
        textBoxes.length > 0 &&
        <LinksSection
          ad={ad}
          boxes={textBoxes}
          indexShift={headBoxes.length}
          device={activeDynamicLayout}
          name={name}
          utmParams={utmParams}
        />
      }
    </WidgetContainer>
  )
}
